import React from 'react';

const AISummarySkeleton = () => {
    return (
        <div className="ai-summary-container">
            <div className="ai-summary-card placeholder-glow">
                <div className="ai-summary-header">
                    <div
                        className="ai-summary-icon placeholder"
                        style={{ width: '32px', height: '32px' }}
                    ></div>
                    <span className="placeholder col-3" style={{ height: '1.125rem' }}></span>
                </div>
                <div className="ai-summary-content">
                    <span className="placeholder col-12 mb-2" style={{ height: '1rem' }}></span>
                    <span className="placeholder col-11 mb-2" style={{ height: '1rem' }}></span>
                    <span className="placeholder col-10 mb-2" style={{ height: '1rem' }}></span>
                    <span className="placeholder col-12 mb-2" style={{ height: '1rem' }}></span>
                    <span className="placeholder col-9" style={{ height: '1rem' }}></span>
                </div>
            </div>
        </div>
    );
};

export default AISummarySkeleton;
